module.exports = __webpack_public_path__ + "static/media/piano-f.28459a67.wav";